import { loadMore } from "../utils/loadMore";

function wineAcademyLoadMore () {
  const producers = document.querySelector('.js-wine-academy-region .js-load-more-list')
  if (producers) loadMore(producers);
}

wineAcademyLoadMore()
